// extracted by mini-css-extract-plugin
export default {"add":"addAddress_add__bgTix","heading":"addAddress_heading__RK745","saveBtn":"addAddress_saveBtn__5nCBL"};